export class ErdvErrors {
    value: ErdvErrorsEnum;
    guid?: string;
}

export enum ErdvErrorsEnum {
    NoError = 0,
    LockTimeError = 1,
    ErdvErrorsEnum,
}
